import { useState, type FormEvent } from 'react';
import { Navigate } from 'react-router';
import { supabase, mensagemDeErro } from '../lib/supabase';
import { useSessao } from '../lib/sessao';
import Aviso from '../componentes/Aviso';
import Marca from '../componentes/Marca';
import Carregando from '../componentes/Carregando';

export default function Login() {
  const { session, carregando } = useSessao();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [enviando, setEnviando] = useState(false);

  if (carregando) return <Carregando texto="Verificando acesso" />;
  if (session) return <Navigate to="/" replace />;

  const entrar = async (e: FormEvent) => {
    e.preventDefault();
    setErro('');
    setEnviando(true);
    const { error } = await supabase.auth.signInWithPassword({ email: email.trim(), password: senha });
    if (error) setErro(mensagemDeErro(error));
    setEnviando(false);
  };

  return (
    <div className="mx-auto flex min-h-svh max-w-sm flex-col justify-center gap-6 p-6">
      <div className="flex items-center gap-3">
        <Marca className="h-9 w-auto text-marca" />
        <div>
          <p className="text-xl font-black italic leading-none tracking-tight">SERGINHO</p>
          <p className="font-mono text-[0.6875rem] uppercase tracking-widest text-dim">
            Estoque e caixa
          </p>
        </div>
      </div>

      <form onSubmit={entrar} className="cartao space-y-4 p-5">
        <div>
          <label htmlFor="email" className="rotulo">E-mail</label>
          <input
            id="email"
            type="email"
            className="campo"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            autoCapitalize="none"
            required
          />
        </div>

        <div>
          <label htmlFor="senha" className="rotulo">Senha</label>
          <input
            id="senha"
            type="password"
            className="campo"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            autoComplete="current-password"
            required
          />
        </div>

        <Aviso tipo="erro">{erro}</Aviso>

        <button type="submit" className="botao-primario w-full" disabled={enviando}>
          {enviando ? 'Entrando…' : 'Entrar'}
        </button>
      </form>

      <p className="text-center text-xs text-dim">
        Esqueceu a senha? O dono redefine na tela de Equipe, na hora.
      </p>
    </div>
  );
}
